export const isSafariOnIphone = () => {
    const userAgent = navigator.userAgent;
    const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(userAgent);

    return isAppleDevice && !/CriOS|FxiOS/.test(userAgent) && /Safari/.test(userAgent);
};
